import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import * as teamsSelectors from 'common.components/classes/selectors';
import { getLessonStatus } from 'common.components/lesson/selectors';
import * as userSelectors from 'common.components/user/selectors';

import { getSpecCourseLessonStatus as getSpecCourseLessonStatusUtil } from '../spec-course.store/utils';

import { SHOW_SPEC_COURSE_BANNER_TEAM_LEVEL } from './constants';

export const getShouldShowStudentsWarning = createSelector(
    [teamsSelectors.getStudentsCount, teamsSelectors.getLoadingStatus],
    (studentsCount, loadingStatus) => studentsCount === 0 && loadingStatus === LOADING_STATUSES.SUCCESS
);

export const getSpecCourseLessonStatus = createSelector([getLessonStatus], (lessonStatus) => {
    return getSpecCourseLessonStatusUtil(lessonStatus);
});

export const getShouldShowSpecCourseBanner = createSelector(
    [userSelectors.getCurrentTeamLevel, getFeatureFlags],
    (currentLevel, featureFlags): boolean =>
        currentLevel !== null &&
        currentLevel < SHOW_SPEC_COURSE_BANNER_TEAM_LEVEL &&
        Boolean(featureFlags?.shouldShowRoverBanner)
);
